import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedFlex,
  ExtendedBox,
  MiniEssay,
  Data,
  Body,
} from '../coreui';

import DynamicBrowseJoinLink from '../helpers';
import FadeIn from '../components/FadeIn';

const PropertyTypes = ({ isLoggedIn }) => {
  return (
    <ExtendedBox>
      <ExtendedFlex
        py={[50, 50, 100]}
        bg="gray.0"
        flexDirection="column"
        m={0}
        mx="auto"
        width={1}
      >
        <MiniEssay
          m={0}
          header={'Commercial Real Estate Property Types'}
        />
        <ExtendedBox
          width="auto"
          overflowX="scroll"
        >
          <FadeIn>
            <ExtendedBox
              bg="white"
              py={40}
              px={20}
              mx="auto"
              width="80%"
              maxWidth={1440}
              minWidth="800px"
            >
              <ExtendedFlex
                maxWidth={1380}
                bg="gray.0"
                pt={10}
                pb={20}
                px={30}
                mx="auto"
                justifyContent="space-evenly"
              >
                <Data
                  type="D5"
                  width={200}
                  px={10}
                >
                  Property Type
                </Data>
                <Data
                  type="D5"
                  width={350}
                  px={10}
                  mr={20}
                >
                  Description
                </Data>
                <Data
                  type="D5"
                  width={650}
                  px={10}
                >
                  Advantages & Disadvantages
                </Data>
              </ExtendedFlex>
              <ExtendedFlex
                maxWidth={1380}
                bg="white"
                py={20}
                px={30}
                mx="auto"
                justifyContent="space-evenly"
              >
                <Body
                  type="B3"
                  px={10}
                  width={200}
                >
                  Multifamily
                </Body>
                <Body
                  type="B3"
                  px={10}
                  width={350}
                  mr={20}
                >
                  Residential buildings that vary by
                  location (urban or suburban) and may be further
                  classified by structure: high-rise, mid-rise,
                  or garden-style.
                </Body>
                <Body
                  type="B3"
                  px={10}
                  width={650}
                >
                  Economic drivers include demographic trends,
                  home ownership, household formation rates,
                  and local employment growth. Leases are typically
                  short term and adjust quickly to market
                  conditions. Generally considered to be one of
                  the more defensive investment types within commercial real estate,
                  though they are still subject to competitive pressures from newer construction.
                </Body>
              </ExtendedFlex>
              <ExtendedFlex
                maxWidth={1380}
                bg="gray.0"
                py={20}
                px={30}
                mx="auto"
                justifyContent="space-evenly"
              >
                <Body
                  type="B3"
                  px={10}
                  width={200}
                >
                  Retail
                </Body>
                <Body
                  type="B3"
                  px={10}
                  width={350}
                  mr={20}
                >
                  Everything from small shopping centers, strip malls,
                  and outlets to large power centers with a &quot;category-dominating&quot;
                  anchor tenant.
                </Body>
                <Body
                  type="B3"
                  px={10}
                  width={650}
                >
                  Most broadly influenced by the state of the
                  national economy generally, especially such
                  indicators as employment growth and consumer
                  confidence levels. More local factors include
                  the property location and its traffic flow;
                  population demographics; and local household
                  incomes and buying patterns. Leases also
                  often have long terms, which means that after a
                  while lease rates may lag current market
                  rates, and step ups may need to wait until lease expirations.
                </Body>
              </ExtendedFlex>
              <ExtendedFlex
                maxWidth={1380}
                bg="white"
                py={20}
                px={30}
                mx="auto"
                justifyContent="space-evenly"
              >
                <Body
                  type="B3"
                  px={10}
                  width={200}
                >
                  Office
                </Body>
                <Body
                  type="B3"
                  px={10}
                  width={350}
                  mr={20}
                >
                  Range from high-rise multi-tenant
                  structures in city business districts to mid-rise
                  single-tenant buildings in suburban areas.
                </Body>
                <Body
                  type="B3"
                  px={10}
                  width={650}
                >
                  Rents and valuations are influenced by employment growth
                  and a regions economic focus.
                  Individualized tenant improvements are usually not very involved, but credit
                  quality of tenants
                  is key; re-leases of office space typically require some lead time to consummate.
                  Office properties
                  often have longer-term leases that can lag behind current market lease rates,
                  so that significant
                  &quot;step-ups&quot; (or &quot;step-downs&quot;) of
                  rental rates may occur when leases expire.
                </Body>
              </ExtendedFlex>
              <ExtendedFlex
                maxWidth={1380}
                bg="gray.0"
                py={20}
                px={30}
                mx="auto"
                justifyContent="space-evenly"
              >
                <Body
                  type="B3"
                  px={10}
                  width={200}
                >
                  Industrial
                </Body>
                <Body
                  type="B3"
                  px={10}
                  width={350}
                  mr={20}
                >
                  Manufacturing facilities, warehouse and distribution centers,
                  research & development (R&D) properties and flex-space.
                </Body>
                <Body
                  type="B3"
                  px={10}
                  width={650}
                >
                  Manufacturing and R&D properties tend to be build-to-suit
                  buildings that can be difficult to &quot;re-tenant&quot; without
                  extensive modifications, while warehouses and distribution
                  centers can be more generic buildings. Industrial properties are
                  also influenced less by local job growth more
                  than by larger economic
                  drivers such as global trade growth (imports and exports)
                  and corporate inventory
                  levels. As with office buildings and retail centers, industrial
                  property leases tend
                  to have long terms, so that over time lease rates can fall
                  behind &quot;market.&quot;
                </Body>
              </ExtendedFlex>
              <ExtendedFlex
                maxWidth={1380}
                bg="white"
                py={20}
                px={30}
                mx="auto"
                justifyContent="space-evenly"
              >
                <Body
                  type="B3"
                  px={10}
                  width={200}
                >
                  Other
                </Body>
                <Body
                  type="B3"
                  px={10}
                  width={350}
                  mr={20}
                >
                  Self-storage facilities, mobile home parks,
                  student housing and hospitality.
                </Body>
                <Body
                  type="B3"
                  px={10}
                  width={650}
                >
                  Key drivers include demographic trends, the state
                  of the national economy in general, and large macroeconomic
                  drivers such as supply/demand.
                </Body>
              </ExtendedFlex>
            </ExtendedBox>
          </FadeIn>
        </ExtendedBox>
        <ExtendedFlex
          pt={60}
          bg="gray.0"
          flexDirection="column"
          align="center"
        >
          <DynamicBrowseJoinLink
            type="L1"
            isLoggedIn={isLoggedIn}
          />
        </ExtendedFlex>
      </ExtendedFlex>
    </ExtendedBox>
  );
};

PropertyTypes.propTypes = {
  isLoggedIn: PropTypes.bool,
};

export default PropertyTypes;
